import * as types from '../mutation-types'
import { stateManager } from '../helper'
import api from '@/libs/api'

const sm = stateManager({
  pending: false,
  data: null
})

export default {
  namespaced: true,
  state: sm.get(),
  mutations: {
    [types.CHARTS_SET] (state, data) {
      state.data = data
    },
    [types.CHARTS_BEGIN_FETCHING] (state) {
      state.pending = true
    },
    [types.CHARTS_END_FETCHING] (state) {
      state.pending = false
    }
  },
  actions: {
    async fetch ({ commit, rootState }) {
      try {
        commit(types.CHARTS_BEGIN_FETCHING)
        const token = await rootState.auth.user.getIdToken()
        const { body } = await api.userbooks.readingVolume(token)
        commit(types.CHARTS_SET, body.data)
      } finally {
        commit(types.CHARTS_END_FETCHING)
      }
    }
  }
}
